import React from "react";
import { Link } from "react-router-dom";
import { Users, Shield, Briefcase } from "react-feather";
import { useClaims } from "../../auth/useClaims";
import { paths } from "../../../routes/paths";

const LINKS = [
  { label: "Users", description: "Create accounts, assign roles, manage branch access.", icon: Users, path: paths.users, permission: "Admin.ManageUsers" },
  { label: "Roles", description: "Business-function permission bundles.", icon: Shield, path: paths.roles, permission: "Admin.ManageRoles" },
  { label: "Designations", description: "Job-title default permissions.", icon: Briefcase, path: paths.designations, permission: "Admin.ManageDesignations" },
];

// Pre-existing "welcome" quick links, carried over from the old Dashboard
// as their own widget rather than dropped - same self-contained shape as
// every other widget (own visibility check, own root element/size).
const AdministrationQuickLinksWidget = () => {
  const { permissions } = useClaims();
  const visibleLinks = LINKS.filter((link) => permissions.includes(link.permission));
  if (visibleLinks.length === 0) return null;

  return (
    <div className="col-12">
      <div className="row g-3">
        <div className="col-12">
          <h6 className="text-muted text-uppercase mb-0" style={{ fontSize: 12, letterSpacing: 0.5 }}>Administration</h6>
        </div>
        {visibleLinks.map(({ label, description, icon: Icon, path }) => (
          <div className="col-xl-4 col-sm-6 col-12" key={path}>
            <Link to={path} className="text-decoration-none">
              <div className="card">
                <div className="card-body d-flex align-items-start">
                  <span className="me-3">
                    <Icon size={28} />
                  </span>
                  <div>
                    <h5 className="mb-1">{label}</h5>
                    <p className="mb-0 text-muted">{description}</p>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdministrationQuickLinksWidget;
